import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label"];
import React from "react";
import Button from "../Button";
import { EMPTY_OBJ } from "../helpers/logic/empties";
import Typography from "../Typography";
import EmptyStateImage from "./components/EmptyStateImage";
import { BaseEmptyStateContainer } from "./styled";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function EmptyState(_ref) {
  var _ref$image = _ref.image,
    image = _ref$image === void 0 ? "folder" : _ref$image,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? "Nothing to display" : _ref$title,
    description = _ref.description,
    buttonProps = _ref.buttonProps;
  var _ref2 = buttonProps || EMPTY_OBJ,
    label = _ref2.label,
    restButtonProps = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/_jsxs(BaseEmptyStateContainer, {
    children: [/*#__PURE__*/_jsx(EmptyStateImage, {
      image: image
    }), /*#__PURE__*/_jsx(Typography, {
      variant: "display200",
      children: title
    }), description && /*#__PURE__*/_jsx(Typography, {
      variant: "caption",
      textAlign: "center",
      children: description
    }), label && /*#__PURE__*/_jsx(Button, _extends({}, restButtonProps, {
      size: "default",
      shouldFitContainer: false,
      appearance: "primary",
      children: label
    }))]
  });
}
export default EmptyState;